import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  readonly lastError = signal<string | null>(null);
  show(message: string) { this.lastError.set(message); setTimeout(() => this.lastError.set(null), 5000); }
}
